import Vue from 'vue'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import LanguageDetector from 'i18next-browser-languagedetector'
import Storage from '@/utils/Storage'

const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
const resources = {}

// load all files from `./locales` as {object}`resources`
for (const key of locales.keys()) {
  const matched = key.match(/([A-Za-z0-9-_]+)\./i)

  if (matched && matched.length > 1) {
    const [, locale] = matched
    resources[locale] = {
      translation: locales(key),
    }
  }
}

// Prevent language not being initialized due old formats
const oldLocales = ['pt_BR', 'eng_US']
const currentLocale = Storage.getItem('locale')
if (oldLocales.includes(currentLocale)) {
  localStorage.setItem('locale', currentLocale.substr(0, 2))
}

i18next.use(LanguageDetector).init({
  debug: process.env.NODE_ENV !== 'production',
  load: 'languageOnly',
  fallbackLng: 'pt',
  resources,
  detection: {
    order: ['querystring', 'localStorage', 'navigator'],
    lookupQuerystring: 'locale',
    lookupLocalStorage: 'locale',
  },
})

Vue.use(I18NextVue, { i18next })

export default i18next
